/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2 } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- USAGE FEES : STYLES --------------- ++++++++++ */
export default  {
  usageFees: {

  },
  product: {
    '& .spacing': {
      marginBottom: pxToEm(20)
    },
    '& .productCol': {
      marginLeft: pxToEm(10),
      display: 'flex',
      flexDirection: 'column'
    }
  },
  usageFee: {
    '& .spacing': {
      marginBottom: pxToEm(20)
    },
    '& .usageFeeCol': {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  updateSuccess: {
    color: themeV2.color.success.main
  },
  updateFailed: {
    color: themeV2.color.error.main
  }
};